import React, { useState } from 'react';
import { connect } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { IContact } from 'src/app/contact/~store/models/Contact';
import { DEFAULT_OPERATOR_AVATAR_ID } from 'src/app/operator/~store/models/ModelsConstants';
import { IOperator } from 'src/app/operator/~store/models/Operator';
import { TagName, TagType } from '../../~types/models/SearchingTag';
import { ISuggetionProps } from './~types/SuggestionProps';
import { ISuggetionReduxProps } from './~types/SuggestionReduxProps';
import { getExistsTagNames, getExistsTagValuesByTagName } from 'src/app/chats/~store/actions/actions';
import { chatTagNamesSelector, chatTagValuesSelector } from 'src/app/chats/~store/selector';
import { IApplicationState } from 'src/~store/models/ApplicationState';
import { Avatar } from '@mui/material';
import ContactIcon from '@mui/icons-material/AccountCircle';
import OperatorIcon from '@mui/icons-material/SupportAgent'
import { GET_FILE_BY_ID_API_ROUTE } from 'src/app/chats-panel/~api/apiRoutes';
import { ContactTagValue } from '../../../../helpers/contact-tag-value/ContactTagValue';
import i18n from "src/app/shared/localization/i18n";

type ReduxType = ReturnType<typeof mapStateToProps> & ISuggetionReduxProps;

const Suggestion = (props: ISuggetionProps & ReduxType) => {
    const [isChatTagsShown, setIsChatTagsShown] = useState(false);
    
    const _createSuggestion = (value: string, key: number) => {        
        if (props.suggestion.tagName === TagName.ChatTag && props.suggestion.tagType === TagType.OpeningTag)
        {
            return _createOpenTagForChatTags();
        } else {
            return (
                <DropdownItem
                    className={props.className}
                    data-testid="search-suggestion"
                    data-tag-name={props.suggestion?.tagName}
                    data-tag-type={props.suggestion?.tagType}
                    key={key}
                    tabIndex={0}
                    onClick={() => {
                        props.suggestion.value = value;
                        props.onSelected(props.suggestion);
                    }}
                    onKeyUp={(e) => {
                        if (e.key === 'Enter') {
                            props.suggestion.value = value;
                            props.onSelected(props.suggestion);
                        }
                    }}
                >
                    {value}
                </DropdownItem>
            );
        }
    }    

    const _createOpenTagForChatTags = () => {
        return (
            <DropdownItem
                tabIndex={0}
                onMouseEnter={() => { props.getExistsTagNames(); setIsChatTagsShown(true) }}
                onMouseLeave={() => setIsChatTagsShown(false)}
                onFocus={() => { props.getExistsTagNames(); setIsChatTagsShown(true) }}
                onBlur={() => setIsChatTagsShown(false)}
                onKeyUp={(e) => {
                    if (e.key === "ArrowRight") {
                        (document.querySelector('.chat-tag-suggestion__dropdown-item') as HTMLDivElement)?.focus();
                    }
                }}
                className={props.className + " chat-tag-suggestion__dropdown"}
                >
                {i18n.t('common.chatTag')}
                {_getTagTypesForChatTags()}
            </DropdownItem>
        );
    }

    const hasRepeatingOpeningChatTag = (tag: string, tags: string[]): boolean => {
        for (var step = 0; step < tags.length; step += 3) {
            if (tags[step] === tag) return true;
        }
        return false;
    }

    const _getTagTypesForChatTags = () => {        
        if (isChatTagsShown) {
            return (
              <div className="chat-tag-suggestion__dropdown-list">
                {props.chatTags.map((s, i) => {
                  if (
                    !hasRepeatingOpeningChatTag(
                      s,
                      props.searchingTag.map((val, i) => {
                        return val.value;
                      })
                    )
                  ) {
                    return (
                      <DropdownItem
                        className={"chat-tag-suggestion__dropdown-item"}
                        key={i}
                        onClick={() => {
                          props.getExistsTagValuesByTagName(s);
                          props.suggestion.value = s;
                          props.onSelected(props.suggestion);
                        }}
                        tabIndex={0}
                      >
                        {s}
                      </DropdownItem>
                    );
                  }
                })}
              </div>
            );
        }
    }

    const _createSuggestionFromOperator = (operator: IOperator, key: number) => {
        const imageUrl = 
            operator.avatarId !== DEFAULT_OPERATOR_AVATAR_ID ? 
            GET_FILE_BY_ID_API_ROUTE + operator.avatarId : 
            "";
        return (
            <DropdownItem
                tabIndex={0}
                className={props.operatorClassName}
                key={key}
                onClick={() => {
                    props.suggestion.value = operator.name.toString();
                    props.onSelected(props.suggestion);
                }} >
                <Avatar
                    className="suggestion-operator__avatar"
                    src={imageUrl}
                >
                    <OperatorIcon style={{ color: "#26a69a" }} />
                </Avatar>
                <div className="suggestion-operator__operator-info">
                    {operator.name}
                </div>
            </DropdownItem>
        )
    }

    const _createSuggestionFromContact = (contact: IContact, key: number) => {
        const imageUrl = contact.avatarId === null ?
            '' :
            GET_FILE_BY_ID_API_ROUTE + contact.avatarId;

        return (
            <DropdownItem
                tabIndex={0}
                className={props.operatorClassName}
                key={key}
                onClick={() => {
                    props.suggestion.value = ContactTagValue(contact);
                    props.onSelected(props.suggestion);
                }}>
                <Avatar
                    className="suggestion-contact__avatar"
                    src={imageUrl}
                >
                    <ContactIcon style={{ color: "#26a69a" }} />
                </Avatar>
                <div className="suggestion-contact__contact-info">
                    {contact.firstName} {contact.lastName} {`${(contact.chatName !== null && contact.chatName.length > 0) ? `(${contact.chatName})`: ""}`}
                    {(contact.phone !== null && contact.phone.length > 0) && <div className="suggestion-contact__contact-phone">
                        +{contact.phone}
                    </div>}
                </div>
            </DropdownItem>
        )
    }

    const hasRepeatingTag = (suggestion: string, openingTag: string, tags: string[]): boolean => {
        for (var step = 2; step < tags.length; step += 3) {
            if (tags[step] === suggestion && tags[step - 2] === openingTag) return true;
        }
        return false;
    }

    const _contactHasAnyName = (contact: IContact): boolean => {
        if(contact.firstName !== null  && contact.firstName.trim() !== "" ||
            contact.lastName !== null && contact.lastName.trim() !== "" ||
            contact.patronymic !== null && contact.patronymic?.trim() !== "")
            return true;
        else
            return false;
    }

    const _anyContactNameIncludesSerarchString = (fullName: string): boolean => {
        return fullName?.toLowerCase().includes(props.searchString.toLowerCase());
    }

    const _getSuggestion = () => {
        if(props.suggestion.tagType !== TagType.ClosingTag) {
            return _createSuggestion(props.suggestion.value, props.keyValue);
        } else {
            switch(props.suggestion.tagName) {
                case TagName.ChatTag:
                    return (
                        <>
                            {props.chatTagValues?.filter(suggestion => {
                                if(props.searchString.length > 0) {
                                    return (suggestion as string).toLowerCase().includes(props.searchString.toLowerCase());
                                } else {
                                    return !hasRepeatingTag(suggestion, props.searchingTag[props.searchingTag.length - 2].value, props.searchingTag.map((val, i) => {return val.value}));
                                }
                            })
                            .map((val, i) => {
                                return _createSuggestion(val?.toString(), i);
                            })}
                        </>
                    )
                case TagName.Source:
                case TagName.Status:
                case TagName.Channel:
                case TagName.ChatType:
                case TagName.Date:
                case TagName.OperatorType: {
                    return (
                        <>
                            {props.suggestion.suggestions?.filter(suggestion => {
                                if(props.searchString.length > 0) {
                                    return (suggestion as string).toLowerCase().includes(props.searchString.toLowerCase());
                                } else {
                                    return true;
                                }
                            })
                            .map((val, i) => {
                                return _createSuggestion(val.toString(), i);
                            })}
                        </>
                    )
                }
                case TagName.Subject: {
                    return (
                        <>
                            {props.suggestion.suggestions?.filter(suggestion => {
                                if (props.searchString.length > 0) {
                                    return (suggestion as string).toLowerCase().includes(props.searchString.toLowerCase());
                                } else {
                                    return true;
                                }
                            })
                                .map((val, i) => {
                                    return _createSuggestion(val.toString(), i);
                                })}
                        </>
                    )
                }
                case TagName.Setting: {
                    return (
                        <>
                            {props.suggestion.suggestions?.filter(suggestion => {
                                if (props.searchString.length > 0) {
                                    return (suggestion as string).toLowerCase().includes(props.searchString.toLowerCase());
                                } else {
                                    return true;
                                }
                            })
                                .map((val, i) => {
                                    return _createSuggestion(val.toString(), i);
                                })}
                        </>
                    )
                }
                case TagName.Operator: {
                    return (
                        <>
                            {props.operators.filter(operator => {
                                if(props.searchString.length > 0) {
                                    if(operator.name !== null)
                                        return operator.name.toLowerCase().includes(props.searchString.toLowerCase());
                                    else
                                        return false;
                                } else {
                                    return true;
                                }
                            })
                            .slice(0, 5)
                            .map((operator, i) => {
                                return _createSuggestionFromOperator(operator, i);
                            })}
                        </>
                    )
                }
                case TagName.Contact: {
                    return (
                        <>
                            {props.contacts.map((contact, i) => {
                                return _createSuggestionFromContact(contact, i);
                            })}
                        </>
                    )
                }
                case TagName.ChatName: {
                    return (
                        <>
                            {props.suggestionItems.filter(chatName => {
                                if (chatName !== null && chatName.trim() !== "") {
                                    if(props.searchString.length > 0) 
                                        return chatName.toLowerCase().includes(props.searchString.toLowerCase());
                                    else 
                                        return true;
                                } else {
                                    return false;
                                }
                            })
                            //get only unique values
                            .filter((chatName, index, self) => {
                                return self.indexOf(chatName) === index;
                            })
                            .slice(0, 5)
                            .map((chatName, i) => {
                                return _createSuggestion(chatName, i)
                            })}
                        </>
                    )
                }
                case TagName.ContactExernalId: {
                    return (
                        <>
                            {props.suggestionItems.filter(externalId => {
                                if (externalId !== null && externalId.trim() !== "") {
                                   if (props.searchString.length > 0)
                                       return externalId.toLowerCase().includes(props.searchString.toLowerCase());
                                   else
                                       return true;
                                } else {
                                    return false;
                                }
                            })
                            //get only unique values
                            .filter((externalId, index, self) => {
                                return self.indexOf(externalId) === index;
                            })
                            .slice(0, 5)
                            .map((externalId, i) => {
                                return _createSuggestion(externalId, i)
                            })}
                        </>
                    )
                }
                case TagName.Phone: {
                    return (
                        <>
                            {props.suggestionItems.filter(phone => {
                                if (phone !== null && phone.trim() !== "") {
                                    if (props.searchString.length > 0) 
                                        return phone.toLowerCase().includes(props.searchString.toLowerCase().replace(/[^\d]/, ""));
                                    else 
                                        return true;
                                } else {
                                    return false;
                                }
                            })
                            //get only unique values
                            .filter((phone, index, self) => {
                                return self.indexOf(phone) === index;
                            })
                            .slice(0, 5)
                            .map((phone, i) => {
                                return _createSuggestion(phone, i)
                            })}
                        </>
                    )
                }
                case TagName.ContactName: {
                    return (
                        <>
                            {props.suggestionItems.filter(fullName => {
                                if (fullName !== null && fullName.trim() !== "") {
                                    if(props.searchString.length > 0) 
                                        return _anyContactNameIncludesSerarchString(fullName);
                                    else 
                                        return true;
                                } else {
                                    return false;
                                }
                            })
                            .slice(0, 5)
                            //get only unique values
                                .filter((fullName, index, self) => {
                                return self.indexOf(fullName) === index;
                            })
                            .map((fullname, i) => {
                                if(fullname !== undefined)
                                    return _createSuggestion(fullname, i)
                            })}
                        </>
                    )
                }
                case TagName.ChannelName: {
                    return (
                        <>
                            {props.channels
                                .filter(channel => {
                                    if(props.searchString.length > 0) {
                                        if(channel.name !== null) {
                                            return channel.name.toLowerCase().includes(props.searchString.toLowerCase()) && props.searchingTag.filter(tag => tag.tagName === TagName.ChannelName && tag.tagType === TagType.ClosingTag && tag.value === channel.name).length === 0;
                                        }
                                        else
                                            return false;
                                    } else {
                                        return props.searchingTag.filter(tag => tag.tagName === TagName.ChannelName && tag.tagType === TagType.ClosingTag && tag.value === channel.name).length === 0;
                                    }
                                })
                                //get only unique values
                                .filter((value, index, self) => {
                                    return self.map(ch => ch.name).indexOf(value.name) === index;
                                })
                                .slice(0, 5)
                                .map((channel, i) => {
                                    return _createSuggestion(channel.name, channel.channelId)
                                })
                            }
                        </>
                    );
                }
                case TagName.TriggerName: {
                    return (
                        <>
                            {props.suggestionItems.filter(triggerName => {
                                if (triggerName !== null && triggerName.trim() !== "") {
                                    if (props.searchString.length > 0)
                                        return triggerName.toLowerCase().includes(props.searchString.toLowerCase());
                                    else
                                        return true;
                                } else {
                                    return false;
                                }
                            })
                            .map((triggerName, i) => {
                                return _createSuggestion(triggerName, i)
                            })}
                        </>
                    )
                }
                case TagName.MessengerExternalId: {
                    return (
                        <>
                            {props.suggestionItems
                                .filter(externalId => {
                                    if (externalId !== null && externalId.trim() !== "") {
                                        if (props.searchString.length > 0)
                                            return externalId.toLowerCase().includes(props.searchString.toLowerCase());
                                        else
                                            return true;
                                    } else {
                                        return false;
                                    }
                                })
                                .filter((externalId, index, self) => {
                                    return self.indexOf(externalId) === index;
                                })
                                .slice(0, 5)
                                .map((externalId, i) => {
                                    return _createSuggestion(externalId, i)
                                })}
                        </>
                    )
                }
                default:
                    return (<></>);
            }
        }
    }

    

    return (
        _getSuggestion()
    )
}

const mapStateToProps = (state: IApplicationState) => {
    return {
        chatTags: chatTagNamesSelector(state),
        chatTagValues: chatTagValuesSelector(state)
    };
}

const mapDispatchToProps = (dispatch: any): ISuggetionReduxProps => {
    return {
        getExistsTagNames: () => dispatch(getExistsTagNames()),
        getExistsTagValuesByTagName: (name: string) => dispatch(getExistsTagValuesByTagName(name))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Suggestion);